import { configureStore } from "@reduxjs/toolkit";
import fetchDemoOpenAiReducer from "../redux/reducers/demo";
import imageLoadReducer from "../redux/reducers/image";
import AuthSlice from "../slices/AuthSlice";
export const store = configureStore({
  reducer: {
    authState: AuthSlice,
    demoOpenAi: fetchDemoOpenAiReducer,
    images: imageLoadReducer,
  },
});
